import api from './config';

// ============================================
// DEPARTAMENTOS
// ============================================
export const departmentsAPI = {
  getAll: async () => {
    const response = await api.get('/departments');
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/departments/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/departments', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/departments/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/departments/${id}`);
    return response.data;
  }
};

// ============================================
// POSICIONES/CARGOS
// ============================================
export const positionsAPI = {
  getAll: async () => {
    const response = await api.get('/positions');
    return response.data;
  },

  getByDepartment: async (departmentId) => {
    const response = await api.get('/positions', {
      params: { department_id: departmentId }
    });
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/positions', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/positions/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/positions/${id}`);
    return response.data;
  }
};

// ============================================
// NÓMINA
// ============================================
export const payrollsAPI = {
  getAll: async (params) => {
    const response = await api.get('/payrolls', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/payrolls/${id}`);
    return response.data;
  },

  getByEmployee: async (employeeId) => {
    const response = await api.get('/payrolls', {
      params: { employee_id: employeeId }
    });
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/payrolls', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/payrolls/${id}`, data);
    return response.data;
  },

  approve: async (id) => {
    const response = await api.patch(`/payrolls/${id}/approve`);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/payrolls/${id}`);
    return response.data;
  }
};

// ============================================
// ASISTENCIA
// ============================================
export const attendanceAPI = {
  getAll: async (params) => {
    const response = await api.get('/attendance', { params });
    return response.data;
  },

  getByEmployee: async (employeeId, params) => {
    const response = await api.get('/attendance', {
      params: { employee_id: employeeId, ...params }
    });
    return response.data;
  },

  checkIn: async (employeeId, data) => {
    const response = await api.post('/attendance/check-in', {
      employee_id: employeeId,
      ...data
    });
    return response.data;
  },

  checkOut: async (attendanceId, data) => {
    const response = await api.post(`/attendance/${attendanceId}/check-out`, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/attendance/${id}`, data);
    return response.data;
  }
};

// ============================================
// TURNOS
// ============================================
export const shiftsAPI = {
  getAll: async () => {
    const response = await api.get('/shifts');
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/shifts', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/shifts/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/shifts/${id}`);
    return response.data;
  }
};

// ============================================
// HORARIOS
// ============================================
export const schedulesAPI = {
  getAll: async (params) => {
    const response = await api.get('/schedules', { params });
    return response.data;
  },

  getByEmployee: async (employeeId) => {
    const response = await api.get('/schedules', {
      params: { employee_id: employeeId }
    });
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/schedules', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/schedules/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/schedules/${id}`);
    return response.data;
  }
};

// ============================================
// VACACIONES
// ============================================
export const vacacionesAPI = {
  getAll: async (params) => {
    const response = await api.get('/vacaciones', { params });
    return response.data;
  },

  getByEmployee: async (employeeId) => {
    const response = await api.get('/vacaciones', {
      params: { employee_id: employeeId }
    });
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/vacaciones', data);
    return response.data;
  },

  approve: async (id) => {
    const response = await api.patch(`/vacaciones/${id}/approve`);
    return response.data;
  },

  reject: async (id, comentarios) => {
    const response = await api.patch(`/vacaciones/${id}/reject`, { comentarios });
    return response.data;
  },

  cancel: async (id) => {
    const response = await api.patch(`/vacaciones/${id}/cancel`);
    return response.data;
  }
};

// ============================================
// PERMISOS
// ============================================
export const permisosAPI = {
  getAll: async (params) => {
    const response = await api.get('/permisos', { params });
    return response.data;
  },

  getByEmployee: async (employeeId) => {
    const response = await api.get('/permisos', {
      params: { employee_id: employeeId }
    });
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/permisos', data);
    return response.data;
  },

  approve: async (id) => {
    const response = await api.patch(`/permisos/${id}/approve`);
    return response.data;
  },

  reject: async (id, comentarios) => {
    const response = await api.patch(`/permisos/${id}/reject`, { comentarios });
    return response.data;
  }
};

// ============================================
// MENÚS DE ALMUERZO
// ============================================
export const lunchMenusAPI = {
  getAll: async (params) => {
    const response = await api.get('/lunch-menus', { params });
    return response.data;
  },

  getByWeek: async (weekStart) => {
    const response = await api.get('/lunch-menus', {
      params: { semana: weekStart }
    });
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/lunch-menus', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/lunch-menus/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/lunch-menus/${id}`);
    return response.data;
  },

  // Selecciones
  select: async (employeeId, menuId, data) => {
    const response = await api.post('/lunch-menus/select', {
      employee_id: employeeId,
      menu_id: menuId,
      ...data
    });
    return response.data;
  },

  getSelections: async (params) => {
    const response = await api.get('/lunch-menus/selections', { params });
    return response.data;
  },

  cancelSelection: async (selectionId) => {
    const response = await api.delete(`/lunch-menus/selections/${selectionId}`);
    return response.data;
  }
};

// ============================================
// USUARIOS
// ============================================
export const usersAPI = {
  getAll: async () => {
    const response = await api.get('/users');
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/users', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/users/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },

  resetPassword: async (id, newPassword) => {
    const response = await api.patch(`/users/${id}/reset-password`, {
      new_password: newPassword
    });
    return response.data;
  }
};
